import { Card, CardActionArea, CardContent, Container, Grid, makeStyles, Typography } from '@material-ui/core';
// import { Details, RowingSharp } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import NewCard from '../../components/NewCard';
import { CommonConfig } from '../../config/common-config';
import OpenTable from './openTable';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    header: {
        color: '#000000',
        margin: theme.spacing(2),
    },
    grid: {
        marginTop: '25px',
        border: '1px none ',
        boxShadow: '5px 5px 5px 5px #888888',
    },
}));
function CoreEMDashboard() {
    const classes = useStyles();
    const [open, setOpen] = useState(true);
    const [dataOpen, setDataOpen] = useState([]);
    const history = useHistory();

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails && tennantDetails.tennantName;
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    // const handleOpen = () => {
    //     setOpen(false);
    // };

    const headcells = [
        { id: 'serviceId', label: 'Service ID' },
        { id: 'clientId', label: 'Client ID' },
        { id: 'clientType', label: 'Client type' },
        { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'serviceYear', label: 'Year' },
        { id: 'startDate', label: 'Start date' },
        { id: 'statusId', label: 'Current status' },
    ];

    // to set the Rows by default
    const getCandidates = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/createservice-employee/${dbname}?page=0&size=5&sort=serviceId,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log("response", response.data);
                setDataOpen(response.data.content);
            })
            .catch((error) => {
                //console.log(error);
            });
    };
    useEffect(() => {
        getCandidates();
    }, [userToken]);

    const handleClickOpen = () => {
        history.push('/menu/openservice');
    };

    return (
        <div className={classes.root}>
            <Typography variant="h6" component="h1" className={classes.header}>
                Dashboard(EM)
            </Typography>
            <Container maxWidth="false">
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <NewCard nameCard="create" title="Create Service" />
                    </Grid>
                    <Grid item xs={4}>
                        <NewCard nameCard="open" title="Open Services" />
                    </Grid>
                    <Grid item xs={4}>
                        <NewCard nameCard="closed" title="Closed Services" />
                    </Grid>
                </Grid>
                <Grid container spacing={1} className={classes.grid}>
                    <Grid item xs={12}>
                        <div style={{ display: 'flex', background: 'white', padding: '14px' }}>
                            <div style={{ paddingTop: '10px' }}>
                                <h5 className="openservice-title">Open Services</h5>
                            </div>
                        </div>
                        <OpenTable
                            headcells={headcells}
                            rows={dataOpen}
                            pageName="coreDashboard"
                            service="open"
                            handleClickOpen={handleClickOpen}
                        />
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default CoreEMDashboard;
